import { Typography } from '@libs/components';
import styled from 'styled-components';
type StatuBarType = {
  isActive: boolean;
};
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.surface.tertiary};
  border-radius: ${({ theme }) => theme.borderRadius.high};
  padding: 1.6rem 1.2rem;
  margin-top: 2rem;
`;
export const Title = styled(Typography)`
  padding-bottom: 1.6rem;
`;
export const StatWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;
export const Body = styled.div`
  width: 100%;
  display: flex;
  gap: 0.4rem;
`;
export const StatusBar = styled.div<StatuBarType>`
  width: 100%;
  height: 0.6rem;
  border-radius: ${({ theme }) => theme.borderRadius.mediumHigh};
  background-color: ${({ theme, isActive }) =>
    isActive ? theme.colors.borders.highlight : theme.colors.borders.default};
  margin-bottom: 0.8rem;
`;
